import React from "react";
import Calendar from "react-calendar";
import "./customCalendar.css";
import CustomModal from "../modal/customModal";

interface IProps {
    isOpen: boolean,
    value: Date,
    maxDate: Date,
    minDate: Date,
    onSelectDate: (date: Date) => void,
    onClose?: () => void
}

const CalendarPicker = (props: IProps) => {
    const {isOpen, value, maxDate, minDate, onSelectDate, onClose} = props

    return (
        <CustomModal isOpen={isOpen} onClose={onClose}>
            <Calendar
                locale={"en"}
                calendarType={"US"}
                minDate={minDate}
                maxDate={maxDate}
                onChange={onSelectDate}
                value={value}
            />
        </CustomModal>
    )
}

export default CalendarPicker
